import moment from 'moment';

function set(state, fn) {
	if (fn)
		fn(state);
}

let setValue = (state, { value, key }) => {
	state[key] = value;
};

function resetDeviationTypeTemplate(state) {
	state.showEditDeviationType = false;
	state.deviationTypeEditId = null;
	state.deviationTypeTemplate = {
		id: null,
		code: '',
		description: '',
		editedDate: {
			date: moment().format('YYYYMMDDHHmm'),
			hasTime: true,
			timeZone: 'Europe/Oslo'
		}
	};
}

function resetDeviationCauseTemplate(state) {
	state.showEditDeviationCause = false;
	state.deviationCauseEditId = null;
	state.deviationCauseTemplate = {
		id: null,
		code: '',
		description: '',
		availableFor: '',
		editedDate: {
			date: moment().format('YYYYMMDDHHmm'),
			hasTime: true,
			timeZone: 'Europe/Oslo'
		}
	};
}

export default {
	set,
	setValue,
	resetDeviationTypeTemplate,
	resetDeviationCauseTemplate
};